// @flow

import * as React from 'react';
import {defineMessage, MessageDescriptor} from 'react-intl';
import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import {FormattedMessageOrString} from 'docs/data/localization/intlUtils';
import {CopyButton} from './CopyButton';

const cards = [
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.success',
        defaultMessage: 'Payment succeeds',
      }),
    },
    number: '4242 4242 4242 4242',
  },
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.auth',
        defaultMessage: 'Payment requires authentication',
      }),
    },
    number: '4000 0025 0000 3155',
  },
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.decline',
        defaultMessage: 'Payment is declined',
      }),
    },
    number: '4000 0000 0000 9995',
  },
];

const terminalCards = [
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.terminal.one',
        defaultMessage: 'Payment succeeds',
      }),
    },
    number: '00',
  },
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.terminal.two',
        defaultMessage: 'Payment is declined',
      }),
    },
    number: '01',
  },
];

type TestCardsProps = {|
  type: string,
|};

export const TestCards = ({type}: TestCardsProps) => {
  switch (type) {
    case 'terminal':
      return <TerminalCards />;
    default:
      return <DefaultCards />;
  }
};

export const TestCard = ({
  label,
  number,
}: {|
  label: MessageDescriptor,
  number: string,
|}) => {
  return (
    <Box
      className="TestCard"
      flex={{alignItems: 'center', justifyContent: 'space-between'}}
      margin={{bottom: 4}}
    >
      <Box flexGrow={1} flexBasis={0}>
        <BodyAlt>
          <FormattedMessageOrString stringOrDefineMessage={label} />
        </BodyAlt>
      </Box>
      <CopyButton text={number} useTextAsLabel />
    </Box>
  );
};

const DefaultCards = () => {
  return (
    <Box margin={{top: 8}}>
      {cards.map((c) => (
        <TestCard key={c.number} label={c.label} number={c.number} />
      ))}
    </Box>
  );
};

const TerminalCards = () => {
  return (
    <Box margin={{top: 8}}>
      {terminalCards.map((c) => (
        <TestCard key={c.number} label={c.label} number={c.number} />
      ))}
    </Box>
  );
};
